import { gql, useMutation } from '@apollo/client';
import { subscriptionsPublicClient } from 'lib/apollo/clients';

export const CREATE_TRIAL = gql`
  mutation createTrial(
    $address: AddressObj
    $bizibleId: String
    $businessName: String
    $currentTrialSlug: String!
    $email: String!
    $firstName: String!
    $googleClickId: String
    $googleClientId: String
    $googlePlaceId: String
    $lastName: String!
    $partnerId: ID
    $password: String!
    $phone: String!
    $postalCode: String!
    $salesforceCampaignId: String
    $sessionId: ID
    $showName: String
    $stripeCustomerId: String
    $stripePaymentMethodId: String
    $stripeSetupIntentId: String
    $tosAccepted: Boolean!
    $userTimezone: String
  ) {
    createTrial(
      address: $address
      bizibleId: $bizibleId
      businessName: $businessName
      currentTrialSlug: $currentTrialSlug
      email: $email
      firstName: $firstName
      googleClickId: $googleClickId
      googleClientId: $googleClientId
      googlePlaceId: $googlePlaceId
      lastName: $lastName
      partnerId: $partnerId
      password: $password
      phone: $phone
      postalCode: $postalCode
      salesforceCampaignId: $salesforceCampaignId
      showName: $showName
      sessionId: $sessionId
      stripeCustomerId: $stripeCustomerId
      stripePaymentMethodId: $stripePaymentMethodId
      stripeSetupIntentId: $stripeSetupIntentId
      tosAccepted: $tosAccepted
      userTimezone: $userTimezone
    ) {
      idToken
      refreshToken
      userUid
      organization {
        id
        uid
        businessName
        locations {
          podiumNumber
          uid
        }
      }
    }
  }
`;

const useCreateTrial = () =>
  useMutation(CREATE_TRIAL, { client: subscriptionsPublicClient });

export default useCreateTrial;
